import axios from 'axios'

export default axios.create()



// WEBPACK FOOTER //
// ./src/api/client.js